import { Flex, Tooltip } from 'antd';

import { prepareDateHistory } from '@/lib/helpers/prepareDate';
import { IHistoryItem, IVideoCollectionItem } from '@/ts';

const collectionsColumns = [
	// {
	//   title: "Title / Description",
	//   dataIndex: "title",
	//   key: "title",
	//   // sorter: false,
	//   ellipsis: true,
	//   width: 90,
	//   render: (_: any, record: IVideoCollectionItem) => {
	//     return (
	//       <Tooltip title={record?.title}>
	//         <Flex vertical>
	//           <span>{record?.title}</span>
	//           <span style={{ color: "gray" }}>{record?.description}</span>
	//         </Flex>
	//       </Tooltip>
	//     );
	//   },
	// },
	// {
	//   title: "Description",
	//   dataIndex: "description",
	//   key: "description",
	//   // sorter: true,
	//   ellipsis: true,
	//   width: 100,
	//   flex: true,
	//   render: (_: any, record: IVideoCollectionItem) => {
	//     return (
	//       <Tooltip title={record?.description}>{record?.description}</Tooltip>
	//     );
	//   },
	// },
	{
		title: 'Videos',
		ellipsis: true,
		width: 35,
		// sorter: true,
		// defaultSortOrder: "descend",
		dataIndex: 'items_count',
		key: 'items_count',
		render: (_: any, record: IVideoCollectionItem) => {
			return (
				<Flex align="center" justify="center" style={{ width: '100%' }}>
					{record?.items_count ?? 0}
				</Flex>
			);
		},
	},
	{
		title: 'Date',
		// ellipsis: true,
		width: 60,
		sorter: true,
		// defaultSortOrder: "descend",
		dataIndex: 'created_at',
		key: 'created_at',
		render: (_: any, record: IVideoCollectionItem) => {
			return record?.created_at
				? prepareDateHistory(record?.created_at?.toString())
				: null;
		},
	},
];

const addRemoveCollectionsColumns = (type: 'videos' | 'creators') => [
	// {
	//   title: "Title",
	//   dataIndex: "title",
	//   key: "title",
	//   // sorter: false,
	//   ellipsis: true,
	//   width: 70,
	//   render: (_: any, record: IVideoCollectionItem) => {
	//     return <Tooltip title={record?.title}>{record?.title}</Tooltip>;
	//   },
	// },
	{
		title: 'Title / Description',
		dataIndex: 'title',
		key: 'title',
		// sorter: false,
		ellipsis: true,
		width: 90,
		render: (_: any, record: IVideoCollectionItem) => {
			return (
				<Tooltip title={record?.title}>
					<Flex vertical>
						<span>{record?.title}</span>
						<span style={{ color: 'gray' }}>{record?.description}</span>
					</Flex>
				</Tooltip>
			);
		},
	},
	// {
	//   title: "Description",
	//   dataIndex: "description",
	//   key: "description",
	//   // sorter: true,
	//   ellipsis: true,
	//   width: 100,
	//   flex: true,
	//   render: (_: any, record: IVideoCollectionItem) => {
	//     return (
	//       <Tooltip title={record?.description}>{record?.description}</Tooltip>
	//     );
	//   },
	// },
	{
		title: type === 'videos' ? 'Videos' : 'Creators',
		ellipsis: true,
		width: 40,
		// sorter: true,
		// defaultSortOrder: "descend",
		dataIndex: 'items_count',
		key: 'items_count',
		render: (_: any, record: IVideoCollectionItem) => {
			return (
				<Flex align="center" justify="center" style={{ width: '100%' }}>
					{record?.items_count ?? 0}
				</Flex>
			);
		},
	},
	{
		title: 'Date',
		ellipsis: true,
		width: 50,
		sorter: true,
		// defaultSortOrder: "descend",
		dataIndex: 'created_at',
		key: 'created_at',
		render: (_: any, record: IVideoCollectionItem) => {
			return record?.created_at
				? prepareDateHistory(record?.created_at?.toString())
				: null;
		},
	},
];

const singleCollectionColumns = [
	{
		title: 'Date',
		ellipsis: true,
		width: 50,
		sorter: true,
		// defaultSortOrder: "descend",
		dataIndex: 'created_at',
		key: 'created_at',
		render: (_: any, record: IHistoryItem) => {
			return record?.created_at
				? prepareDateHistory(record?.created_at?.toString())
				: null;
		},
	},
	// {
	//   title: "Status / Title",
	//   dataIndex: "title",
	//   key: "title",
	//   // sorter: false,
	//   ellipsis: true,
	//   width: 200,
	//   render: (_: any, record: IHistoryItem) => {
	//     let IconComponent = null;

	//     switch (record?.status) {
	//       case 0:
	//       case undefined:
	//         IconComponent = (
	//           <Tooltip title={t("adding_to_queue")}>
	//             <LoadingOutlined
	//               style={{ color: "gray" }}
	//               className={styles.indicatorIcon}
	//             />
	//           </Tooltip>
	//         );
	//         break;

	//       case 1:
	//         IconComponent = (
	//           <Tooltip title={t("processing")}>
	//             <SyncOutlined
	//               spin
	//               style={{
	//                 color: "#172b6f",
	//               }}
	//               className={styles.indicatorIcon}
	//             />
	//           </Tooltip>
	//         );
	//         break;

	//       case 2:
	//         IconComponent = (
	//           <Tooltip title={t("checklist_analysis_complete")}>
	//             <CheckCircleOutlined
	//               style={{
	//                 color: "#58C622",
	//               }}
	//               className={styles.indicatorIcon}
	//             />
	//           </Tooltip>
	//         );
	//         break;

	//       case 3:
	//       case 4:
	//       case 5:
	//         IconComponent = (
	//           <Tooltip title={t("issues_on_processing")}>
	//             <ExclamationCircleOutlined
	//               style={{
	//                 color: "orange",
	//               }}
	//               className={styles.indicatorIcon}
	//             />
	//           </Tooltip>
	//         );
	//         break;

	//       default:
	//         IconComponent = (
	//           <Tooltip title={t("adding_to_queue")}>
	//             <LoadingOutlined
	//               style={{ color: "gray" }}
	//               className={styles.indicatorIcon}
	//             />
	//           </Tooltip>
	//         );
	//         break;
	//     }

	//     const popoverContent = <InfoPopover record={record} />;

	//     const buttonComponent = (
	//       <Button
	//         type="link"
	//         href={record?.url}
	//         onClick={async (e) => {
	//           e.preventDefault();

	//           // if (activeTabUrl === record?.url && record?.status === 2) {
	//           //   // setActiveMenuTab("key-insights");
	//           //   setHistoryItem(record?.url);
	//           //   setOpenDrawer(true);
	//           //   return;
	//           // } else if (activeTabUrl === record?.url) {
	//           //   return;
	//           // }

	//           // setHistoryItem(record?.url);
	//           // setOpenDrawer(true);

	//           try {
	//             const [currentTab = null] = await chrome?.tabs.query({
	//               active: true,
	//               currentWindow: true,
	//             });

	//             if (currentTab && currentTab?.id) {
	//               await chrome?.tabs.update(currentTab.id, {
	//                 url: record?.url,
	//               });
	//             }
	//           } catch (error) {
	//             console.error("Error updating tab:", error);
	//           }
	//         }}
	//         style={{ padding: 0 }}
	//       >
	//         {record?.title || record?.description ? (
	//           <>{record?.title || record?.description}</>
	//         ) : record?.url ? (
	//           <>{record?.url}</>
	//         ) : (
	//           <code>no title</code>
	//         )}
	//       </Button>
	//     );

	//     return (
	//       <Flex gap={4} align="flex-start" vertical>
	//         {/* {record?.status !== 2 ? (
	//       <FieldTimeOutlined style={{ color: "gray" }} />
	//     ) : (
	//       <CheckCircleOutlined style={{ color: "#58C622" }} />
	//     )} */}

	//         <Flex vertical align="flex-start" justify="space-between">
	//           <Flex gap={4} align="center">
	//             {IconComponent}

	//             <Popover
	//               content={popoverContent}
	//               // title={"Video"}
	//               placement="bottomLeft"
	//             >
	//               {buttonComponent}
	//             </Popover>
	//           </Flex>
	//         </Flex>
	//       </Flex>
	//     );
	//   },
	// },

	// {
	//   title: "Status",
	//   dataIndex: "status",
	//   key: "status",
	//   sorter: true,
	//   width: 80,
	//   // ellipsis: true,
	//   render: (_: any, record: IHistoryItem) => {
	//     return (
	//       <Flex justify="center" align="center">
	//         {record?.status === "processing" ? (
	//           <FieldTimeOutlined style={{ color: "gray" }} />
	//         ) : (
	//           <CheckCircleOutlined style={{ color: "#58C622" }} />
	//         )}
	//       </Flex>
	//     );
	//   },
	// },
];

export {
	collectionsColumns,
	addRemoveCollectionsColumns,
	singleCollectionColumns,
};
